import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$orgSlug/admin/settings/faq")({
  // Component in lazy file for code splitting
});
